import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this tied to a specific barre method or certification?',
  a: 'No. It uses standard barre positions, written in plain English, and works alongside whatever certification you hold. It is not affiliated with any studio brand or method, and it does not replace your training.'
}, {
  q: "It's a PDF. How will I know what the move looks like?",
  a: 'Every block gives you the setup, the sequence in 8-counts, 3–4 short cues, an easy and a hard version, and the most common error with its fix, alongside simple line figures with direction arrows. It is written for instructors who already know the base positions.'
}, {
  q: 'I already pay for a choreography subscription. Why would I need this?',
  a: 'A library gives you new songs. This gives you the order: what to teach each week, for a whole year, with a progression behind it. It is a single payment, and plenty of instructors pull extra tracks from a library into the map.'
}, {
  q: 'Do I have to start at Week 1?',
  a: 'No. Bonus 01, Start Anywhere, tells you which volume and week fits your room right now — useful if you are buying mid-season.'
}, {
  q: 'What about music?',
  a: 'Every block lists a BPM and a structure, never song titles or lyrics. You teach it to any music you are licensed to play in your setting.'
}, {
  q: 'Is it 52 completely new classes?',
  a: 'Each class has about seven blocks: four or five are new that week and two or three come back from earlier weeks in the same volume, on purpose, so the progression builds. Warm-ups and cooldowns change every month.'
}, {
  q: 'Does it cover injuries, pregnancy or postpartum clients?',
  a: 'Blocks include easier versions and a note on who to refer out when something hurts. Clients with injuries, pregnancy or postpartum questions should check with a health professional first.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Landscape PDFs that read well on a phone or tablet mid-class and print cleanly for the studio.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-cream text-ink" data-id="element-81" data-mp="1fq3xkw28xqr5">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-82" data-mp="2ddmdqry8lv56">
        <div className="text-center" data-id="element-83" data-mp="28hnlgt9sfszh">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-84" data-mp="28ej6d0usbcu1">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-85" data-mp="1zggzw5sa7rzd">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-86" data-mp="o0iwahfvhy5j">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-cream-dark bg-white" data-id="element-87" data-mp="2zpyszvaz2j54" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-semibold text-plum focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-88" data-mp="38ok9lkwvvo39">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-89" data-mp="3rftn059ryx04" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-90" data-mp="1x2kheokcnvn5" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-91" data-mp="16s9ze7o7j6v0">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}